import _ from 'lodash';

// Replacement for angular.isDefined()
const isDefined = (value) => {
    return typeof value !== 'undefined';
};

function Vehicle(data) {
    if (data) {
        _.extend(this, data);
    }
    // this.costNew = this.costNew || {};

    if (!isDefined(this.costNew)) {
        this.costNew = {
            amount: 0,
            currency: 'usd'
        };
    }

    if (!isDefined(this.lastVehicleInspection_ML)) {
        this.lastVehicleInspection_ML = {};
    }
    if (_.isUndefined(this.additionalInterests_ML)) {
        this.additionalInterests_ML = [];
    }
}

Vehicle.prototype.getDisplayName = function (defaultName) {
    let name = this.make || '';
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }
    if (this.year) {
        if (name) {
            name += ' ';
        }
        name += this.year;
    }
    if (name.length < 1) {
        name = defaultName;
    } else if (this.license) {
        name += ' (';
        name += this.license;
        if (this.licenseState) {
            name += '/';
            name += this.licenseState;
        }
        name += ')';
    }
    return name;
};

Vehicle.prototype.getYearMakeNameML = function () {
    let name = this.year || '';
    if (this.make && typeof this.make === 'string') {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getModelNameML = function () {
    let name = '';
    if (this.model && typeof this.model === 'string') {
        name += this.model;
    }

    return name;
};

Vehicle.prototype.getTrimNameML = function () {
    let name = '';
    if (this.trim_ML && typeof this.trim_ML === 'string') {
        name += this.trim_ML;
    }

    return name;
};

Vehicle.prototype.getYearMakeModelNameML = function () {
    let name = this.year || '';
    if (this.make) {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getVehicleStatesForCountry = (states, countryCode) => {
    return _.filter(states, (state) => {
        const countryConstraint = _.find(state.categories, (constraint) => {
            return _.keys(constraint).indexOf('Country') !== -1;
        });
        if (countryConstraint) {
            return countryConstraint.Country === countryCode;
        }
        return false;
    });
};

Vehicle.prototype.getDisplayNameWithBodyTypeAndTrim = function (InsuranceSuiteMetadata, translator) {
    const bodyTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('BodyType');
    const bodyTypeCode = bodyTypelist.getCode(this.bodyType).name;
    const bodyTypeName = translator({id: bodyTypeCode, defaultMessage: bodyTypeCode});
    return [this.year, this.make, this.model, bodyTypeName, this.trim_ML].filter((e) => !!e).join(' ');
};

Vehicle.prototype.getFixedId = function () {
    return this.fixedId;
};

export default Vehicle;
